import React from "react";
import { MyCellGroupPanel } from "../components/MyCellGroupPanel";

export default function MyCellGroup() {
  return (
    <div className="max-w-6xl mx-auto" data-testid="my-cell-group-page">
      <MyCellGroupPanel withHero />
    </div>
  );
}
